import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { TableauUserFragmentGql } from './TableauUserFragmentGql';

export const DatabaseCertificationFragmentGql: DocumentNode = gql`
fragment DatabaseCertificationFragment on Database {
  isCertified
  certificationNote
  certifier {
    ...TableauUserFragment
  }
}
${TableauUserFragmentGql}
`;
